import { getCurrentCulture } from 'owa-localize';

export interface CategorySortRow<T> {
    row: T;
    category: string;
}

export function createCategorySortCollator(): Intl.Collator {
    return new Intl.Collator(getCurrentCulture() || undefined, { sensitivity: 'variant' });
}

/**
 * Like the folder list, a multi-category row occurs once in each category group. Equal-category
 * rows retain the supplied newest-first order; uncategorized rows form the empty-value group.
 */
export default function sortRowsByCategory<T>(
    rows: readonly T[],
    getCategories: (row: T) => readonly string[] | undefined,
    descending: boolean
): CategorySortRow<T>[] {
    const collator = createCategorySortCollator();
    const direction = descending ? -1 : 1;
    return rows
        .flatMap(row => {
            const categories = [
                ...new Set(getCategories(row)?.filter(category => category !== '')),
            ];
            return (categories.length ? categories : ['']).map(category => ({ row, category }));
        })
        .sort(
            (a, b) =>
                direction *
                (collator.compare(a.category, b.category) ||
                    (a.category < b.category ? -1 : a.category > b.category ? 1 : 0))
        );
}
